// utilities.ts
import { assertSchema } from "./errors.mjs";
import { registry } from "./registry.mjs";
function getValidator(validation) {
  assertSchema(validation !== void 0, "No validator for undefined validation");
  if (validation === null) return new (registry.get("constant"))(null);
  if (validation[Symbol.justusValidator]) {
    return validation[Symbol.justusValidator];
  }
  switch (typeof validation) {
    // constants
    case "boolean":
    case "bigint":
    case "string":
    case "number":
      return new (registry.get("constant"))(validation);
    // other objects...
    case "object":
      if (Array.isArray(validation)) return new (registry.get("tuple"))(validation);
      return new (registry.get("object"))(validation);
    // definitely not one of our types
    default:
      throw new TypeError(`Invalid validation (type=${typeof validation})`);
  }
}
export {
  getValidator
};
//# sourceMappingURL=utilities.mjs.map
